import React from "react";
import "./Portfolio.css";
/* import IMAGE1 from "../../assets/portfolio1.png"; */
import IMAGE2 from "../../assets/portfolio2.png";
import IMAGE3 from "../../assets/portfolio3.png";
/* import IMAGE4 from "../../assets/portfolio4.png"; */
import IMAGE5 from "../../assets/portfolio5.png";
import IMAGE6 from "../../assets/portfolio6.png";

const Portfolio = () => {
  return (
    <section id="portfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {/*  <article className="portfolio__item">
          <div className="portfolio_item-image">
            <img src={IMAGE1} alt="" />
          </div>

          <h3>ABubakar Mahboob</h3>
          <div className="portfolio_item-cta">
            <a
              href="https://github.com/arslanazharr"
              target="_blank"
              rel="noopener noreferrer"
              className="btn"
            >
              Github
            </a>
            <a
              href="https://arslanazharr.github.io/arslanazhar/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Live Demo
            </a>
          </div>
        </article> */}

        <article className="portfolio__item">
          <div className="portfolio_item-image">
            <img src={IMAGE2} alt="" />
          </div>

          <h3>Personal Portfolio Website</h3>
          <div className="portfolio_item-cta">
            {/*  <a
              href="https://github.com/arslanazharr"
              target="_blank"
              rel="noopener noreferrer"
              className="btn"
            >
              Github
            </a> */}
            <a
              href="#header"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Live Demo
            </a>
          </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio_item-image">
            <img src={IMAGE3} alt="" />
          </div>

          <h3>Fauget Website</h3>
          <div className="portfolio_item-cta">
            {/*   <a
              href="https://github.com/arslanazharr"
              target="_blank"
              rel="noopener noreferrer"
              className="btn"
            >
              Github
            </a> */}
            <a
              href="https://fauget-clothing.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Live Demo
            </a>
          </div>
        </article>

        {/*  <article className="portfolio__item">
          <div className="portfolio_item-image">
            <img src={IMAGE4} alt="" />
          </div>

          <h3>Arslan Azhar (previous portfolio website)</h3>
          <div className="portfolio_item-cta">
            <a
              href="https://github.com/arslanazharr"
              target="_blank"
              rel="noopener noreferrer"
              className="btn"
            >
              Github
            </a>
            <a
              href="https://arslanazharr.github.io/my-portfolio/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Live Demo
            </a>
          </div>
        </article> */}

        <article className="portfolio__item">
          <div className="portfolio_item-image">
            <img src={IMAGE5} alt="" />
          </div>

          <h3>Utah Skis Dashboard</h3>
          <div className="portfolio_item-cta">
            <a
              href="https://utah-skis-dashboard.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Live Demo
            </a>
          </div>
        </article>

        <article className="portfolio__item">
          <div className="portfolio_item-image">
            <img src={IMAGE6} alt="" />
          </div>

          <h3>EOD Adventure Park</h3>
          <div className="portfolio_item-cta">
            {/*    <a
              href="https://github.com/arslanazharr"
              target="_blank"
              rel="noopener noreferrer"
              className="btn"
            >
              Github
            </a> */}
            <a
              href="https://eod-adventure-park.netlify.app/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              Live Demo
            </a>
          </div>
        </article>
      </div>
    </section>
  );
};

export default Portfolio;
